export default {
  name: 'Breadcrumbs',
  //---components
  //---data
  data () {
    return {
      breadcrumbsCollection: [],
    }
  },
  //---hooks
  created: function () {
    let routes = this.$router.options.routes,
        currentRoute = this.$router.currentRoute;

    routes.forEach(route => {
      if(route.name === 'home') {
        this.breadcrumbsCollection.push({
          title: route.meta.title,
          path: route.path,
          isDisabled: false
        })
      } else if (route.name === currentRoute.name) {
        this.breadcrumbsCollection.push({
          title: route.meta.title,
          path: route.path,
          isDisabled: true
        })
      }
    });
  },
}